module.exports = __webpack_public_path__ + "img/9.61cb245b.png";